import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BellAlertIcon,
  BugAntIcon,
  CloudIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { buildWeatherAgronomyPath } from '../../../utils/weatherAgronomyContext';
import { buildBusinessContextPath } from '../../../utils/businessContextNav';

const PestWarningSection = ({
  pestWarnings = [],
  weatherWarnings = [],
  deviceWarnings = [],
  onPestWarningClick,
  loading,
  farmId = '',
  landId = '',
  deviceId = '',
}) => {
  const navigate = useNavigate();
  const ctx = { farmId: farmId || '', landId: landId || '', deviceId: deviceId || '' };

  const pestCount = pestWarnings.length;
  const weatherCount = weatherWarnings.length;
  const deviceCount = deviceWarnings.length;

  if (!loading && pestCount === 0 && weatherCount === 0 && deviceCount === 0) {
    return null;
  }

  return (
    <div className="mb-8 bg-white rounded-xl border border-gray-200 px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
      <div className="flex items-center gap-2 shrink-0">
        <BellAlertIcon className="h-4 w-4 text-orange-500" aria-hidden />
        <span className="text-sm font-semibold text-gray-800">预警提醒</span>
      </div>

      <div className="flex flex-wrap items-center gap-3 flex-1">
        {pestCount > 0 && (
          <button
            type="button"
            onClick={() => navigate(buildBusinessContextPath('/production/field-work/pest-control', ctx))}
            className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-red-700 transition-colors"
          >
            <BugAntIcon className="h-4 w-4 text-red-600" aria-hidden />
            <span>病虫害预警</span>
            <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-600 text-white text-xs font-semibold">
              {pestCount}
            </span>
          </button>
        )}

        {weatherCount > 0 && (
          <button
            type="button"
            onClick={() => navigate(
              buildWeatherAgronomyPath('/weather-agronomy/disaster-warning', {
                farmId: farmId || '',
                landId: landId || '',
              })
            )}
            className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-orange-700 transition-colors"
          >
            <CloudIcon className="h-4 w-4 text-orange-500" aria-hidden />
            <span>气象预警</span>
            <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-orange-500 text-white text-xs font-semibold">
              {weatherCount}
            </span>
          </button>
        )}

        {deviceCount > 0 && (
          <button
            type="button"
            onClick={() => navigate(buildBusinessContextPath('/production/land/smart-device', ctx))}
            className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-blue-700 transition-colors"
          >
            <Cog6ToothIcon className="h-4 w-4 text-blue-600" aria-hidden />
            <span>设备异常</span>
            <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-blue-600 text-white text-xs font-semibold">
              {deviceCount}
            </span>
          </button>
        )}
      </div>

      <button
        type="button"
        onClick={() => navigate(buildBusinessContextPath('/production/field-work/warning-management', ctx))}
        className="text-sm text-gray-600 hover:text-green-700 whitespace-nowrap shrink-0 transition-colors"
      >
        查看全部
      </button>
    </div>
  );
};

export default PestWarningSection;
